import Vue from 'vue'

const AskInstance = Vue.extend(require('./ask.vue').default);
let instance = null
let confirmPromise = null
let confirmResolve = null

let getInstance = () => {
  return new AskInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (confirmResolve) {
    confirmResolve(false)
    confirmResolve = null
  }
  confirmPromise = null
}

let Ask = (config) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  confirmPromise = new Promise((resolve, reject) => {
    confirmResolve = resolve
  })
  instance.open(config, confirmResolve)

  return confirmPromise
}

export default Ask
